import * as React from 'react';

/**
 * @description HouseVacations icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { HouseVacations } from '@sravni/design-system-icons'
 *
 * <HouseVacations />
 * ```
 */
const HouseVacations = React.forwardRef((props, ref) => (React.createElement("svg", { ref: ref, "data-qa": "HouseVacations", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
    React.createElement("path", { d: "m1.667 9.444 7.597-6.927a1.064 1.064 0 0 1 1.472 0l7.597 6.927", stroke: "currentColor", strokeWidth: "1.5", strokeMiterlimit: "10", strokeLinecap: "round" }),
    React.createElement("path", { d: "M13 10.101c0 1.803-1.28 3.49-3 3.899-1.72-.41-3-2.095-3-3.899V8.685c0-.323.184-.613.466-.735l1.875-.813a1.65 1.65 0 0 1 1.318 0l1.875.813a.796.796 0 0 1 .466.735V10.1Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "m11 10-1.25 1-.75-.6", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M15 6V3", stroke: "currentColor", strokeWidth: "1.5", strokeMiterlimit: "10", strokeLinecap: "round" }),
    React.createElement("path", { d: "M16.667 7.778v7.619c0 .702-.597 1.27-1.334 1.27H4.667c-.737 0-1.334-.569-1.334-1.27v-7.62", stroke: "currentColor", strokeWidth: "1.5", strokeMiterlimit: "10" }))));

export { HouseVacations };
//# sourceMappingURL=HouseVacations.js.map
